import * as React from 'react'; // tslint:disable-line
import { FormProvider, ModalStateProvider, ActiveLangProvider, EntityProvider, AppStateProvider, EmbedComponentsProvider, EntityLayoutsProvider, SiteProvider, AvailableEntitiesProvider, KnowledgeHubStateProvider } from '@shapeable/web';
import { MenusProvider } from './providers/menus-provider';
import { SiteMetadataProvider } from './providers/site-metadata-provider';
import { ImageProvider } from './providers/image-provider';
import { EventsProvider } from './providers/events-provider';
import { LinkProvider } from './providers/link-provider';
import { PeopleProvider } from './providers/people-provider';
import { PostsProvider } from './providers/posts-provider';
import { TopicsProvider } from './providers/topics-provider';
import { VideosProvider } from './providers/videos-provider';
import { FeedEntriesProvider } from './providers/feed-entries-provider';
import { ParallaxProvider } from 'react-scroll-parallax';
import { CitationsProvider } from './providers/citations-provider';
import { EntityTypeName, HasChildren } from '@shapeable/types';
import { PagesProvider } from './providers/pages-provider';
import { ChallengesProvider } from './providers/challenges-provider';
import { OrganisationsProvider } from './providers/organisations-provider';

const ENTITY_PROVIDERS: Partial<Record<EntityTypeName, React.FC<any>>> = {
  Challenge: ChallengesProvider,
  Citation: CitationsProvider,
  Event: EventsProvider,
  FeedEntry: FeedEntriesProvider,
  Organisation: OrganisationsProvider,
  Page: PagesProvider,
  Person: PeopleProvider,
  Post: PostsProvider,
  Topic: TopicsProvider,
  Video: VideosProvider,
};

export const GatsbyProviders: React.FC<any> = (props) => {
  const { children, pageContext = {}, path } = props;

  // TODO - conditionally apply providers based on entity config (a list of which can be passed via page context - not much data)
  // Should also allow entities to be supported, but providers to be switched off if they will be overridden anyway (potentially huge waste of data).
  // Strategy - create an Entities Provider which takes the entity config from page Context and handles this.

  const { availableEntities = [] } = pageContext;

  // create a wrapping EntitiesProvider component based on what's available
  // console.log("AVAILABLE ENTITIES", availableEntities);

  const EntitiesProvider: React.FC<HasChildren> = ({ children }) => {
    return availableEntities.reduce((acc, entityTypeName) => {
      const Provider = ENTITY_PROVIDERS[entityTypeName];
      return Provider ? <Provider>{acc}</Provider> : acc;
    } , children);
  };

  return (
    <AvailableEntitiesProvider value={availableEntities}>
    <ActiveLangProvider value={pageContext.lang}>
    <KnowledgeHubStateProvider>
    <AppStateProvider>
    <ModalStateProvider>
    <ParallaxProvider>
    <EmbedComponentsProvider>
    <FormProvider>
      <EntitiesProvider>
      <MenusProvider>
        <SiteProvider value={pageContext.site}>
        <SiteMetadataProvider>
        <ImageProvider>
        <LinkProvider>
        <EntityProvider value={{ ...pageContext, path }}>
        {children}
        </EntityProvider>
        </LinkProvider>
        </ImageProvider>
        </SiteMetadataProvider>
        </SiteProvider>
      </MenusProvider>
      </EntitiesProvider>
    </FormProvider>
    </EmbedComponentsProvider>
    </ParallaxProvider>
    </ModalStateProvider>
    </AppStateProvider>
    </KnowledgeHubStateProvider>    
    </ActiveLangProvider>
    </AvailableEntitiesProvider>
  );
}